<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="logbookGeneral.plane_type"
          field-name="plane_type"
          rules="required"
          type="text"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="logbookGeneral.plane_regnum"
          field-name="plane_regnum"
          rules="required|alpha_dash|min:4|max:10"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <date-field
          v-model="logbookGeneral.date"
          field-name="date"
          rules="required|date"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="logbookGeneral.takeoff_airport"
          field-name="takeoff_airport"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="logbookGeneral.takeoff_time"
          field-name="takeoff_time"
          rules="required|time"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="logbookGeneral.landing_airport"
          field-name="landing_airport"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="logbookGeneral.landing_time"
          field-name="landing_time"
          rules="required|time"
        />
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <time-field
          v-model="logbookGeneral.flight_time"
          field-name="flight_time"
          rules="required|time"
          disabled
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGeneral.pft_pic"
          :label="$t('fields.pft_pic')"
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGeneral.pft_copilot"
          :label="$t('fields.pft_copilot')"
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGeneral.pft_dual"
          :label="$t('fields.pft_dual')"
          dense
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-checkbox
          v-model="logbookGeneral.pft_instructor"
          :label="$t('fields.pft_instructor')"
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <validated-text-field
          v-model="logbookGeneral.pic_name"
          field-name="pic_name"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="logbookGeneral.takeoff_day"
          field-name="takeoff"
          rules="required|numeric|min_value:1|max_value:50"
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <validated-text-field
          v-model="logbookGeneral.comment"
          field-name="comment"
          rules="max:500"
          type="text"
        />
      </v-col>
    </v-row>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('Műveletek részletezése') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="logbookGeneral.takeoff_day"
                field-name="takeoff_day"
                rules="required|numeric|min_value:1|max_value:50"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="logbookGeneral.takeoff_night"
                field-name="takeoff_night"
                rules="required|numeric|min_value:0|max_value:50"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="logbookGeneral.landing_day"
                field-name="landing_day"
                rules="required|numeric|min_value:1|max_value:50"
                type="number"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <validated-text-field
                v-model="logbookGeneral.landing_night"
                field-name="landing_night"
                rules="required|numeric|min_value:0|max_value:50"
                type="number"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('Kiegészítő adatok') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                v-model="logbookGeneral.multi_engine"
                :label="$t('fields.multi_engine')"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <v-checkbox
                v-model="logbookGeneral.multi_pilot"
                :label="$t('fields.multi_pilot')"
                dense
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <time-field
                v-model="logbookGeneral.night_time"
                field-name="night_time"
                rules="required|time"
              />
            </v-col>
            <v-col
              cols="12"
              md="3"
            >
              <time-field
                v-model="logbookGeneral.ifr_time"
                field-name="ifr_time"
                rules="required|time"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header>
          {{ $t('Szimulátor adatok') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <validated-text-field
                v-model="logbookGeneral.sim_type"
                field-name="sim_type"
                rules=""
                type="text"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <date-field
                v-model="logbookGeneral.sim_date"
                field-name="sim_date"
                rules="date"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <time-field
                v-model="logbookGeneral.sim_time"
                field-name="sim_time"
                rules="required|time"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
  export default {
    name: 'EditLogbookGeneral',
    props: {
      logbookGeneral: Object,
    },
  }
</script>
